import { Badge } from "@/design-system";
import type { IntegrationMethod } from "@/pages/landingPage/constants/integrations";

const methodTone: Record<IntegrationMethod, "brand" | "secondary"> = {
  API: "brand",
  PLANILHA: "secondary",
};

type IntegrationMethodBadgesProps = {
  methods: IntegrationMethod[];
};

export const IntegrationMethodBadges = ({
  methods,
}: IntegrationMethodBadgesProps) => (
  <ul aria-label="Formas de integração" className="flex flex-wrap gap-1.5">
    {methods.map(method => (
      <li key={method}>
        <Badge tone={methodTone[method]}>{method}</Badge>
      </li>
    ))}
  </ul>
);
